import React from 'react'
import MosaicInput from './MosaicInput'
import PropTypes from 'prop-types'

function ConfigureMosaicStyle ({ state, onChange }) {
  return (
    <div>
      <MosaicInput
        inputTitle='Top Bar Background'
        id='top-bar-color'
        className='form-control'
        type='text'
        value={state.topBarColor}
        onChange={onChange('topBarColor')}
      />
      <MosaicInput
        inputTitle='Campaign Hashtag'
        id='hashtag-color'
        className='form-control'
        type='text'
        value={state.topRightBarTitle}
        onChange={onChange('topRightBarTitle')}
      />
      <MosaicInput
        inputTitle='Find Me Button Background'
        id='search-button-color'
        className='form-control'
        type='text'
        value={state.searchButtonColor}
        onChange={onChange('searchButtonColor')}
      />
      <MosaicInput
        inputTitle='Bottom Bar Background'
        id='bottom-bar-color'
        className='form-control'
        type='text'
        value={state.bottomBarColor}
        onChange={onChange('bottomBarColor')}
      />
      <MosaicInput
        inputTitle='Bottom Bar Text'
        id='bottom-bar-text-color'
        className='form-control'
        type='text'
        value={state.bottomBarTextColor}
        onChange={onChange('bottomBarTextColor')}
      />
      <MosaicInput
        inputTitle='Zoom In Button Color'
        id='zoom-in-button-color'
        className='form-control'
        type='text'
        value={state.zoomInButtonColor}
        onChange={onChange('zoomInButtonColor')}
      />
      <MosaicInput
        inputTitle='Zoom Out Button Color'
        id='zoom-out-button-color'
        className='form-control'
        type='text'
        value={state.zoomOutButtonColor}
        onChange={onChange('zoomOutButtonColor')}
      />
      <MosaicInput
        inputTitle='Zoom Animation Duration'
        id='zoom-animation-duration'
        className='form-control'
        type='number'
        value={state.zoomAnimationDuration}
        onChange={onChange('zoomAnimationDuration')}
      />
    </div>
  )
}

ConfigureMosaicStyle.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ConfigureMosaicStyle



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/MosaicStyle.js